enum SourceType {
	git = "Git",

	gitLab = "GitLab",
	gitHub = "GitHub",
	gitVerse = "GitVerse",
	gitea = "Gitea",

	confluenceCloud = "Confluence Cloud",
	confluenceServer = "Confluence self-hosted server",

	notion = "Notion",
}

export default SourceType;
